import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Awards from "@/components/Awards";
import NewUpdates from "@/components/NewUpdates";
import About from "@/components/About";
import WhyChooseUs from "@/components/WhyChooseUs";
import Pricing from "@/components/Pricing";
import Features from "@/components/Features";
import Industries from "@/components/Industries";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative bg-[#FAF9F6]">
      <Navbar />
      <main>
        <Hero />
        <Awards />
        <NewUpdates />
        <About />
        <WhyChooseUs />
        <Pricing />
        <Features />
        <Industries />
        <Services />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
